"use strict";

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _sliders = require("../../styles/sliders");

var _reactSlick = _interopRequireDefault(require("react-slick"));

require("slick-carousel/slick/slick.css");

require("slick-carousel/slick/slick-theme.css");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var _default = function _default(props) {
  var carouselRef = (0, _react.useRef)();

  var _useState = (0, _react.useState)(0),
      index = _useState[0],
      setIndex = _useState[1];

  var settings = {
    arrows: false,
    dots: props.dots || false,
    autoplay: props.autoplay || false,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 0,
    infinite: props.infinite || false,
    adaptiveHeight: false,
    afterChange: function afterChange(current) {
      return setIndex(current);
    }
  };
  return /*#__PURE__*/_react["default"].createElement(_sliders.MainContainer, null, /*#__PURE__*/_react["default"].createElement(_sliders.FullContainer, null, /*#__PURE__*/_react["default"].createElement(_sliders.CarouselContainer, null, /*#__PURE__*/_react["default"].createElement(_sliders.FullSliderContainer, {
    dotsBottomOffset: props.dots && props.dotsBottomOffset ? props.dotsBottomOffset : '',
    dotsActiveColor: props.dots && props.dotsActiveColor ? props.dotsActiveColor : '',
    dotsPassiveColor: props.dots && props.dotsPassiveColor ? props.dotsPassiveColor : '',
    dotsWidth: props.dots && props.dotsWidth ? props.dotsWidth : '',
    dotsFontSize: props.dots && props.dotsFontSize ? props.dotsFontSize : ''
  }, /*#__PURE__*/_react["default"].createElement(_reactSlick["default"], _extends({}, settings, {
    ref: carouselRef
  }), props.children.map(function (child, index) {
    return /*#__PURE__*/_react["default"].createElement(_sliders.SliderChild, {
      key: index
    }, child);
  }))))));
};

exports["default"] = _default;
module.exports = exports["default"];